import { Component, Input } from '@angular/core';

@Component({
  selector: 'skelton-loader',
  templateUrl: './skelton-loader.component.html',
  styleUrls: ['./skelton-loader.component.scss'],
})
export class SkeltonLoaderComponent {
  @Input() height: string = '150px';
  @Input() width: string = '100%';
  @Input() shape: string = '';
  @Input() borderRadius: string = '0px';
}
